import Card from "../../../../components/card/card"
import Footer from "../../../footer/footer"
import Header from "../../../header/header"
import { IMAGES } from "../../../../../assets/images"
import { useNavigate, useSearchParams } from "react-router-dom"
import { routerPath } from "../../../../navigation/path"
import { useEffect, useState } from "react"
import { categoryList, productList } from "../../service"
import NoData from "../../component/no-data"
import Skeleton from "../../component/skeleton";
const Offer = () => {
    const navigate = useNavigate()
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [searchParams] = useSearchParams();
    const [categoriyId, setCategoriyId] = useState(searchParams.get('category_id') || '')
    const [product, setProduct] = useState([])
    const [category, setcategory] = useState([])

    const [completeData, setCompleteData] = useState([])
    const [serchText, setSearchText] = useState('')
    const [menu, setMenu] = useState('offer')
    const [Loading, setLoading] = useState(true);

    useEffect(() => {
        getCategoryList()
        getProductByCat()
    }, [categoriyId])

    useEffect(() => {
        const filterData = completeData.filter((item) => item.name.toLowerCase().includes(serchText.toLowerCase()))
        setProduct(filterData)
    }, [serchText])

    const getProductByCat = async () => {

        try {
            console.log(categoriyId)
            setLoading(true)
            const res = await productList({ cat_id: categoriyId == null ? '' : categoriyId, product_type: 1 })
            console.log(res)
            setProduct(res.data)
            setCompleteData(res.data)
            setLoading(false)
        } catch (err) {
            console.log(err)
        }
    }

    const getCategoryList = async () => {
        try {
            const res = await categoryList()
            console.log(res)
            setcategory([{ id: '', name: 'ALL', parent_id: null, status: 1, image: '', createdAt: '', updatedAt: '' }, ...res.data])
        } catch (err) {
            console.log(err)
        }
    }

    const productClick = (data) => {
        navigate(`${routerPath.claimOffer}?offer_id=${data.id}`)
    }


    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const serchaTextChange = (e) => {
        setSearchText(e.target.value)
    }
    return (
        <>
            <div className="bg-[#f1f1f1]">
                <Header />
                <div className="container mx-auto">
                    <div className="grid grid-cols-4 gap-5">
                        <div className="col-span-1 py-5 lg:block hidden">
                            <div className=" flex bg-white mb-3">
                                <input type="text" className="w-[90%] p-2 text-black" placeholder="Search" value={serchText} onChange={serchaTextChange} />
                                <img src={IMAGES.search} alt="" />
                            </div>
                            <div className="bg-white p-3">
                                <h6 className="font-bold border-b border-[#f1f1f1] py-2">
                                    Product categories
                                </h6>
                                <div>
                                    {/* <p className="font-bold text-sm">
                                        Offers
                                    </p> */}
                                    <div className="ml-4">
                                        {
                                            category.map((e) =>
                                                <button className={`text-sm  cursor-pointer my-3 block ${e.id == categoriyId ? 'text-[#000000] font-semibold border-b' : 'text-[#757575]'}`} key={e.id} onClick={() => setCategoriyId(e.id)}>{e.name} </button>
                                            )
                                        }

                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="col-span-4 lg:col-span-3">
                            {
                                Loading ?
                                    <div style={{ marginTop: '47px', width: '100%' }}>
                                        <Skeleton width="100%" />
                                    </div>
                                    :
                                    <div>
                                        <div className="grid lg:grid-cols-3 grid-cols-1 sm:py-5 py-5">
                                            {product && product?.length > 0
                                                ?
                                                <>
                                                    {

                                                        product.map((e, i) =>
                                                            <div className="px-2 overflow-hidden" key={e.id}>
                                                                <Card cardType='Heading' img={e?.image1} title={e.name} isClaimed={false} click={() => productClick(e)} />
                                                            </div>
                                                        )
                                                    }
                                                </>
                                                :
                                                <>
                                                    <>
                                                        <div className="px-2 overflow-hidden text-center">
                                                            <NoData />
                                                        </div>
                                                    </>
                                                </>
                                            }

                                        </div>
                                    </div>
                            }

                        </div>

                    </div>
                </div>
                <Footer />
            </div>
        </>
    )
}

export default Offer